{
  "name": "@ns/update-public-ledger-config-key",
  "version": "1.1.0",
  "description": "Update a nodeStream public ledger config key",
  "inputs": {
    "entityId": {
      "type": "string"
    },
    "type": {
      "type": "string"
    }
  },
  "outcomes": {
    "update": {},
    "cancel": {}
  },
  "jobMetadata": [
    "JOB_STATUS"
  ],
  "publicLedger": [
    {
      "id": "signatory-change",
      "outcome": "update",
      "kind": "SIGNATORY_CHANGE"
    }
  ]
}
